/* unplugin-vue-components disabled */import { render } from "./news_m.vue?vue&type=template&id=6a8e4337&scoped=true"
import script from "./news_m.vue?vue&type=script&lang=js"
export * from "./news_m.vue?vue&type=script&lang=js"

import "./news_m.vue?vue&type=style&index=0&id=6a8e4337&lang=css"
import "./news_m.vue?vue&type=style&index=1&id=6a8e4337&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8e4337"]])

export default __exports__